import React from 'react'
import ReactDOM from 'react-dom'
import promise from 'redux-promise'
import createLogger from 'redux-logger'
import thunk from 'redux-thunk'
import freeze from 'redux-freeze'
import { createEpicMiddleware } from 'redux-observable'
import { Provider } from 'react-redux'
import { ConnectedRouter as Router, routerMiddleware } from 'react-router-redux'

import WithRoutes from 'aria-viewer/core/components/WithRoutes'
import epics from 'aria-viewer/core/epics'

import { createBrowserHistory, createHashHistory } from 'history'
import qhistory from 'qhistory'

import { stringify, parse } from 'qs'

import { isDevelopment, isLocalDevelopment, isProduction } from '../utils/environment'
import UriHandler from '../utils/uriHandler'

import { configureStore } from './configureStore'
import bugsnagClient from './bugsnagClient'
import bugsnagMiddleware from 'aria-viewer/core/middleware/bugsnagMiddleware'
import Window from 'aria-viewer/tour/containers/window'
import { batch } from 'redux-batch-middleware'

import appMiddleware from 'aria-viewer/core/middleware/appMiddleware'
import { Iterable } from 'immutable'
import { StyleRoot } from 'radium'
import { getAnalyticsMiddleware } from 'aria-viewer/core/middleware/analyticsMiddleware'
import idleMiddleware from 'aria-viewer/core/middleware/idleMiddleware'
import idleAnalytics from 'aria-viewer/core/analytics/idleAnalytics'
import { AppContainer } from 'react-hot-loader'
import { Provider as MOBXProvider } from 'mobx-react'
import streams from './streams'
import { Browser } from '../legacy'
import { v4 } from 'uuid'

import applyBrowserHacks from './browserHacks'

import { createMuiTheme } from '@material-ui/core/styles'
import { ThemeProvider, JssProvider } from 'react-jss'
import { default as theme } from './theme'

import dynamicMiddlewares from 'redux-dynamic-middlewares'

export default (App, Analytics) => {
    // Use hashHistory for local development for hotloading support.
    const history = qhistory(isLocalDevelopment() ? createHashHistory() : createBrowserHistory(), stringify, parse)

    let middleWares = [
        thunk,
        batch,
        promise,
        routerMiddleware(history),
        appMiddleware,
        createEpicMiddleware(epics),
        dynamicMiddlewares,
        idleMiddleware(idleAnalytics),
    ]

    if (isDevelopment()) {
        middleWares = [...middleWares]

        // For IE let's not include redux-freeze. This will cause an out of stack error!
        if (!Browser.is('ie')) middleWares.push(freeze)
    } else if (isProduction()) {
        middleWares = [
            ...middleWares,
            // bugsnagMiddleware(),
        ]
    }

    // init pendo tracking //
    const urlParams = history.location.search
    const yvCompaign = UriHandler.hasQueryParam('yv_campaign', urlParams)
    const fromSearch = UriHandler.hasQueryParam('fromSearch', urlParams)

    // Initialize Gainsight //
    const getCookie = name => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) {
            return parts
                .pop()
                .split(';')
                .shift()
        }
        return undefined
    }

    const userkey = getCookie('userkey')
    const embed = getCookie('embed')
    const uuid = v4()

    if (yvCompaign || fromSearch) {
        if (pendo) pendo.initialize()
        if (aptrinsic)
            aptrinsic(
                'identify',
                {
                    id: userkey || embed || uuid,
                },
                { id: `account ${userkey || embed || uuid}` }
            )
    }

    // end Gainsight //

    const store = configureStore(middleWares)

    const render = App => {
        ReactDOM.render(
            <AppContainer key={Math.random()}>
                <ThemeProvider theme={createMuiTheme(theme)}>
                    <StyleRoot>
                        <MOBXProvider streams={streams}>
                            <Provider store={store}>
                                <Window>
                                    <Router history={history} children={WithRoutes(App, Analytics)} />
                                </Window>
                            </Provider>
                        </MOBXProvider>
                    </StyleRoot>
                </ThemeProvider>
            </AppContainer>,
            document.getElementById('application')
        )
    }

    applyBrowserHacks()

    render(App)

    return render
}
